module.exports = __webpack_public_path__ + "static/media/cert_99.b29b523c.jpg";